import * as yup from "yup";
const validations = yup.object().shape({
  product: yup.string().required("validationMessages.required"),
  type: yup.string().required("validationMessages.required"),
});

export default validations;
